import { LoginImage } from '../LoginImage/LoginImage';
import {
  BrandingContainer,
  BrandingImageContainer,
  BrandingTextContainer,
  LoginInfoWrapper,
  LoginTitleContainer,
} from './LoginInfo.styles';

//  <img src="/img/presentacion-copres.jpg" alt="" />
export function LoginInfo() {
  return (
    <LoginInfoWrapper>
      <LoginTitleContainer>
        <p>Mis</p>
        <p>Tarjetas</p>
      </LoginTitleContainer>
      <BrandingContainer>
        <BrandingTextContainer>
          <p className="title">
            Mis Tarjetas Recargables: nuevas soluciones para las necesidades de su empresa
          </p>
          <p>
            El programa <span>Mis Tarjetas Recargables</span> le brinda soluciones
            integrales de gran flexibilidad.
          </p>
          <p>
            <span>Mis Tarjetas Recargables</span> es una herramienta única para acceder
            vía Internet a la información de las tarjetas Visa Recargables de su compañía.
          </p>
          <p>
            Le permitirá asociar las tarjetas a Centros de Costos, reasignarles fondos,
            obtener reportes de actividad de todas las operaciones realizadas y definir
            otros usuarios del sistema dentro de su empresa.
          </p>
          <p>
            Para ingresar, utilice su Nombre de Usuario y Código de Acceso. Si usted no
            posee esta información, verifique en su empresa si está autorizado para
            ingresar al sistema.
          </p>
        </BrandingTextContainer>
        <BrandingImageContainer>
          <LoginImage />
        </BrandingImageContainer>
      </BrandingContainer>
    </LoginInfoWrapper>
  );
}
